import { Route } from '@angular/router';
import { Permissions } from '../../../../access/shared/authorization/permissions';
import { CommandeParamListComponent } from './commande-param-list.component';

export const CommandeParamListRouting: Route = {
  path: 'list',
  component: CommandeParamListComponent,
  data: {
    breadcrumb: "Liste",
    'role': [
      Permissions.ROLE_HEBERGEMENT,
    ],
  }
};
